import ResultHotelPage from 'components/hotel/Result/ResultHotelPage';
import { FC, useContext } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import DetailsHotelPageModal from './DetailsHotelPageModal';
import { MainContext } from 'contexts/MainContext';
import { HotelConfigContext } from 'contexts/HotelConfigContext';

const CResultHotelPage: FC = () => {
  const { hotelIndex } = useContext(HotelConfigContext);
  const { userSiteConfig } = useContext(MainContext);
  const { pathname, search } = useLocation();
  const strHotelIndex = hotelIndex === 2 ? '2' : '';
  const [urlParams, setUrlParams] = useSearchParams();

  const onCloseDetails = () => {
    urlParams.delete('details');
    setUrlParams(urlParams);
  };
  return (
    <div className="result-hotel-page">
      <ResultHotelPage />
      {!userSiteConfig.base?.openDetailsInNewTab && (
        <div
          style={{
            display:
              pathname === `/hotels${strHotelIndex}/results` && search.includes('details=')
                ? 'block'
                : 'none',
          }}
        >
          <DetailsHotelPageModal onClose={onCloseDetails} />
        </div>
      )}
    </div>
  );
};

export default CResultHotelPage;
